/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/static-property-placement */

import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { device } from '../../helpers/screenSizes';
import Button from '../button';
import Modal from '../modal';

export const StyledButton = styled(Button)`
  margin: 15px 15px 15px 15px;
  width: 150px;
  height: 40px;
  border-radius: 2px;
  text-align: center;
  &.confirm-ok-button {
    color: #ffffff;
    &:hover {
      background: var(--brand-bg-hover);
    }
  }
  &.confirm-no-button {
    color: var(--brand-text-primary);
    border: solid 1px var(--brand-bg-primary) !important;
    background: none;
    &:hover {
      background: var(--brand-bg-primary);
      color: #ffffff;
    }
  }

  @media ${device.down.md} {
    width: 165px;
    height: 42px;
    &.confirm-ok-button {
      margin-left: 0;
    }
    &.confirm-cancel-button {
      margin-right: 0;
    }
  }
`;

export const Wrapper = styled.div`
  background: ${props => props.theme.secondaryBackground || 'inherit'};
  color: ${props => props.theme.primaryText};
  padding: 0px;
  width: 500px;
  height: fit-content;
  border-radius: 4px;
  box-shadow: 0 5px 4px 0 ${props => props.theme.boxShadow};
  &.close-position {
    padding: 60px 0 45px;
    width: 450px;
    position: relative;
    svg {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
    .confirm-text {
      padding-bottom: 10px;
      padding: 0;
    }
    .buttons {
      margin-top: 25px;
      padding-bottom: 0;
    }
  }

  h3 {
    padding: 10px 0;
    font-family: var(--fontRegular);
    font-size: 20px;
    text-align: center;
    background: ${props => props.theme.secondaryBackground};
  }
  .secondary-text2 {
    color: ${props => props.theme.secondaryText};
    svg {
      height: 14px;
      width: 14px;
      g > g {
        stroke: ${props => props.theme.negative};
      }
    }
  }

  .confirm-text {
    font-family: var(--fontRegular);
    font-size: 16px;
    text-align: center;
    margin-top: 0px;
    padding: 20px;
    color: var(--main-text-secondary);
    .side-long {
      color: var(--positive);
    }
    .side-short {
      color: var(--negative);
    }
    .product-name {
      color: var(--main-text-primary);
    }
  }

  .buttons {
    display: flex;
    gap: 15px;
    // flex-direction: row-reverse;
    justify-content: center;
    margin-top: 15px;
    padding-bottom: 20px;
    .confirm-cancel-button {
      background: none;
      border: 1px solid grey;
    }
  }

  @media ${device.down.md} {
    width: 100%;
    height: fit-content;
    border-radius: 4px;
    box-shadow: 0 5px 4px 0 ${props => props.theme.boxShadow};
    background-color: ${props => props.theme.primaryBackground};
    // transform: translate(15%, 15%);
    padding: 2px;

    h3 {
      font-size: 18px;
      border-bottom: 1px solid ${props => props.theme.separator};
      margin-top: 0;
    }
    .confirm-text {
      font-size: 14px;
      margin-top: 0px;
    }
    .buttons {
      margin-top: 0px;
      padding-bottom: 0px;
    }
  }
`;

export default class Confirm extends React.Component {
  static propType = {
    confirmText: PropTypes.func.isRequired,
    okLabel: PropTypes.string.isRequired,
    cancelLabel: PropTypes.string.isRequired,
    okAction: PropTypes.func.isRequired,
    cancelAction: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    okLabel: 'Yes',
    cancelLabel: 'Cancel',
    confirmText: () => 'Are you Sure?',
    cancelAction: () => null,
    okAction: () => null,
  };

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: props.isModalOpen,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({
      isModalOpen: props.isModalOpen,
    });
  }

  closeModal = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  cancelAction = () => {
    this.closeModal();
    this.props.cancelAction();
  };

  okAction = () => {
    this.closeModal();
    this.props.okAction();
  };

  render() {
    const { heading } = this.props;
    return (
      <Modal
        isOpen={this.state.isModalOpen}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        onRequestClose={this.props.onRequestClose}
        style={this.props.style}
        className={this.props.class}
      >
        <Wrapper>
          <h3>{heading || 'Confirm'}</h3>
          <div className="confirm-text">{this.props.confirmText()}</div>
          <div className="buttons">
            <StyledButton
              data-testid="DNV3bkjxYI5dsSbu4uOqc"
              className="confirm-cancel-button"
              primary
              onClick={this.cancelAction}
            >
              {this.props.cancelLabel}
            </StyledButton>
            <StyledButton
              data-testid="YxklL6gpEKYlIRA5aYNfN"
              className="confirm-ok-button"
              primary
              onClick={this.okAction}
            >
              {this.props.okLabel}
            </StyledButton>
          </div>
        </Wrapper>
      </Modal>
    );
  }
}
